// src/App.tsx

import { Provider } from 'react-redux';
import { store } from './store/store';
import AppRouter from './router/AppRouter';
import AppBootGate from './components/auth/AppBootGate';
import { useProactiveCentralRefresh } from './hooks/useProactiveCentralRefresh';
import { TestingModeBanner } from './components/testingMode/TestingModeBanner';
import AccessChangedNotice from './components/access/AccessChangedNotice';

// DEV ONLY: Log auth rehydration on app init
if (import.meta.env.DEV) {
  const centralAuth = store.getState().centralAuth;
  const legacyAuth = store.getState().auth;

  console.log('[App Init] Auth Rehydration:', {
    central: {
      hasAccessToken: !!centralAuth.accessToken,
      hasRefreshToken: !!centralAuth.refreshToken,
      hasUser: !!centralAuth.user,
      isAuthenticated: centralAuth.isAuthenticated,
      selectedWorkspace: centralAuth.selectedWorkspace?.name,
    },
    legacy: {
      hasToken: !!legacyAuth.token,
      hasUser: !!legacyAuth.user,
    },
  });
}

/**
 * AppContent component with proactive token refresh.
 * Must be inside Redux Provider to access store state.
 */
function AppContent() {
  // Enable proactive token refresh for Central auth
  useProactiveCentralRefresh();

  // AppBootGate picks the boot path: the new OIDC RP `RpBootGate` when
  // HANDOFF_OIDC_CRM is enabled, the legacy Bearer-model `BootGate` otherwise.
  return (
    <AppBootGate>
      <TestingModeBanner />
      {/* Inside the boot gate: it needs a hydrated context to refresh, and a
          member who is not booted has nothing to be told about yet. */}
      <AccessChangedNotice />
      <AppRouter />
    </AppBootGate>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}
